module.exports = __webpack_public_path__ + "img/banner2.ea6c4f62.jpg";